import React from 'react';
import classNames from 'classnames';
/**
 * Bronson [Pagination](https://bronson.vwfs.io/bluelabel/components/detail/bronson-pagination.html) component.
 */
export function Pagination({ children, nextDisabled, nextText, onNextClick, onPrevClick, prevDisabled, prevText, title, testId, ...otherProps }) {
    const aClassNameList = classNames({
        'c-pagination__link ': true,
        'c-pagination__link--stepper-prev ': true,
    }).trim();
    const aClassNameList2 = classNames({
        'c-pagination__link ': true,
        'c-pagination__link--stepper-next ': true,
    }).trim();
    function renderPrevious() {
        return (React.createElement("a", { role: "link", className: aClassNameList, "aria-disabled": prevDisabled, href: prevDisabled ? undefined : '#', onClick: onPrevClick },
            React.createElement("span", { className: "u-visually-hidden" }, prevText)));
    }
    function renderNext() {
        return (React.createElement("a", { role: "link", className: aClassNameList2, "aria-disabled": nextDisabled, href: nextDisabled ? undefined : '#', onClick: onNextClick },
            React.createElement("span", { className: "u-visually-hidden" }, nextText)));
    }
    return (React.createElement("nav", { ...otherProps, "data-testid": testId, className: "c-pagination", "aria-label": title },
        React.createElement("ul", { className: "c-pagination__list" },
            React.createElement("li", { className: "c-pagination__item" }, renderPrevious()),
            children /* Use 'Pagination.Item' component. */,
            React.createElement("li", { className: "c-pagination__item" }, renderNext()))));
}
Pagination.displayName = 'Pagination';
/**
 * Bronson PaginationItem component (nested).
 */
export function PaginationItem({ active, children, disabled, more, moreText = 'show more', onClick, ...otherProps }) {
    const aClassNameList = classNames({
        'c-pagination__link ': true,
    }).trim();
    function renderIfMore() {
        if (!more)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { "aria-hidden": true }, "..."),
            React.createElement("span", { className: "u-visually-hidden" }, moreText)));
    }
    function renderItem() {
        return (React.createElement("a", { role: "link", className: aClassNameList, "aria-disabled": disabled, "aria-current": active ? 'page' : undefined, href: disabled ? undefined : '#', onClick: onClick }, more ? renderIfMore() : children));
    }
    return (React.createElement("li", { ...otherProps, className: "c-pagination__item" }, renderItem()));
}
PaginationItem.displayName = 'Pagination.Item';
Pagination.Item = PaginationItem;
